// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_Vjn","cls2":"Cta-cls2_4H1 Cta-cls1_Vjn"};